var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.16,21.29h-12.32c-.51,0-.97-.19-1.33-.55-.36-.36-.55-.82-.55-1.33v-8.61c0-.56.16-1.04.47-1.43.33-.42.83-.64,1.42-.64h12.32c.51,0,.96.19,1.33.55.37.36.56.83.56,1.34v8.8c0,.52-.19.97-.55,1.33-.36.36-.82.55-1.33.55Zm-13.11-8.42v6.53c0,.22.07.4.23.56.16.16.34.23.56.23h12.32c.22,0,.4-.07.56-.23.16-.16.23-.34.23-.56v-6.52c-.17.17-.36.32-.57.47l-4.27,2.97c-.19.14-.34.24-.47.33-.13.09-.28.18-.46.29-.2.12-.4.21-.59.27-.42.14-.81.13-1.2,0-.18-.06-.38-.15-.59-.27-.18-.11-.34-.2-.46-.29-.12-.08-.28-.19-.47-.33l-.35-.25c-.5-.35-1.24-.86-2.19-1.52-.95-.66-1.52-1.06-1.72-1.19,0,0-.02-.01-.03-.02-.19-.13-.37-.28-.55-.46Zm2.89.75l.03.02c.96.66,1.69,1.17,2.2,1.53l.36.26c.18.13.32.23.44.31.11.08.25.16.41.25.14.08.26.14.37.18.21.07.34.06.51,0,.12-.04.24-.1.38-.18.16-.09.3-.18.41-.26.11-.08.26-.18.44-.31l.36-.26,3.92-2.72c.35-.24.65-.54.88-.89.21-.31.31-.62.31-.95,0-.22-.07-.4-.23-.55-.16-.16-.34-.23-.56-.23h-12.32c-.34,0-.48.12-.56.23-.15.19-.23.44-.23.75,0,.23.12.5.35.81.27.36.55.64.85.84h0c.15.12.56.4,1.21.85,0,0,0,0,0,0,.01,0,.03.02.04.03t0,0s0,0,0,0c0,0,0,0,0,0,0,0,.01,0,.02.01,0,0,0,0,.01,0,0,0,.02.01.02.02,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.02.01.04.03.06.04,0,0,0,0,0,0,.02.01.03.02.04.03.03.02.06.04.09.06.02.02.05.03.07.05,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,0,0,0,0l.04.03Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.29d2da362cbda160960a60c049a0d720.svg";
export { ForwardRef as ReactComponent };